// Baustein 6: alte Analyzer-Route ohne dealId -> /check (Parameter bleiben erhalten);
// mit dealId (Formular „Annahmen prüfen“ aus der Objektseite) -> unverändert.
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import type { QuickCheckObjektart } from "../lib/quickCheckDraft";
import { checkUmleitungsZiel, hatDealId } from "../lib/analyzerUmleitung";

export function AnalyzerOderCheck({ objektart, children }: { objektart: QuickCheckObjektart; children: React.ReactNode }) {
  const location = useLocation();
  if (!hatDealId(location.search)) return <Navigate to={checkUmleitungsZiel(objektart, location.search)} replace />;
  return <>{children}</>;
}
